exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree__body--btn{display:none}.romanov-section{padding-top:35px}", ""]);

// exports
